/** User-facing copy for Firebase Auth errors (never show raw Firebase messages). */
const AUTH_ERROR_MESSAGES = {
  "auth/weak-password": "Choose a password with at least 6 characters.",
  "auth/invalid-credential": "Your current password is incorrect.",
  "auth/wrong-password": "Your current password is incorrect.",
  "auth/too-many-requests":
    "Too many attempts. Please wait a few minutes and try again.",
  "auth/requires-recent-login":
    "For security, sign out and sign back in, then try changing your password again.",
  "auth/user-mismatch": "Something went wrong with your session. Please sign in again.",
  "auth/network-request-failed":
    "Network error. Check your connection and try again.",
};

function extractAuthCode(error) {
  if (error?.code && String(error.code).startsWith("auth/")) {
    return error.code;
  }
  const match = String(error?.message || "").match(/\(auth\/[^)]+\)/);
  return match ? match[0].slice(1, -1) : null;
}

export function getFirebaseAuthErrorMessage(
  error,
  fallback = "Something went wrong. Please try again."
) {
  const code = extractAuthCode(error);
  if (code && AUTH_ERROR_MESSAGES[code]) {
    return AUTH_ERROR_MESSAGES[code];
  }
  return fallback;
}
